/* 横並びで表示されるインプットフィールドを生成する */
import React from 'react';

interface Props {
  name: string;
  placeholder: string;
  valid_message: string;
  unchangeable_flg: boolean;
  handleInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const HorizontalInputField: React.FC<Props> = ({
  name,
  placeholder,
  valid_message,
  unchangeable_flg,
  handleInput,
}) => {
  const padding = name === 'first_name' ? 'col-5 pr-1' : 'col-5 pl-1';

  return (
    <div className={padding}>
      <input
        type="text"
        name={name}
        className={`form-control ${valid_message.length !== 0 && 'textarea-error'}`}
        placeholder={placeholder}
        onBlur={handleInput}
        disabled={unchangeable_flg}
        maxLength={25}
      />
    </div>
  );
};

export default HorizontalInputField;
